import { useCallback } from "react";
import { PriceItemInterface } from "../types/interfaces";

export const useDisplayPrice = () => {
  return useCallback((prices: PriceItemInterface[] | undefined): number => {
    if (!prices || prices.length === 0) return 0;
    return prices[0]?.price ?? 0;
  }, []);
};
